import axios from "axios";
axios.defaults.baseURL =
  "https://zg6d2m03cj.execute-api.ap-east-1.amazonaws.com";

async function connectApi({
  method = "GET",
  url,
  payload,
  headers = {},
  responseType = "json",
}) {
  return await axios({
    method,
    url,
    data: payload,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("jwt"),
      "Content-Type": "application/json",
      Accept: "application/json",
      ...headers,
    },
    responseType,
  });
}

const baseURL = {
  fetchSignedUrl: "/signed-url",
  submitForm: "", // ⚠️ 改成你真實 submit API path
};

export async function fetchSignedUrl() {
  const config = {
    method: "GET",
    url: baseURL.fetchSignedUrl,
  };
  return await connectApi(config);
}

export async function submitForm(payload) {
  const config = {
    method: "POST",
    url: baseURL.submitForm,
    payload,
  };
  return await connectApi(config);
}

export async function saveToBucket(signedUrl, file, opts = {}) {
  const {
    contentType = file?.type || "application/octet-stream",
    extraHeaders = {},
    onUploadProgress,
    timeout = 60000,
  } = opts;

  const res = await axios.put(signedUrl, file, {
    headers: {
      "Content-Type": contentType,
      ...extraHeaders,
    },
    withCredentials: false,
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
    timeout,
    onUploadProgress,
    transformRequest: (data) => data,
    responseType: "text",
    validateStatus: (status) => status >= 200 && status < 400,
  });

  return {
    ok: true,
    status: res.status,
    etag: res.headers?.etag,
  };
}
